// extracted by mini-css-extract-plugin
export default {"controlButton":"HrnWtM","hidden":"qdod1T","timeWrapper":"Vlq0Q2","time":"OLDODn","duration":"lOmGqr","liveMode":"sqZSwh","separator":"QXQX9z"};